module.exports = __webpack_public_path__ + "static/media/googlepay_1.125e8a1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/googlepay_1.png
// module id = 1904
// module chunks = 0